import { forwardRef } from "react";

export const WhatsAppGlyph = () => (
  <svg viewBox="0 0 32 32" className="mc-wa-glyph" aria-hidden="true">
    <path
      fill="currentColor"
      d="M16 3C8.8 3 3 8.7 3 15.8c0 2.5.7 4.9 2 6.9L3 29l6.5-2c1.9 1 4.1 1.6 6.5 1.6 7.2 0 13-5.7 13-12.8S23.2 3 16 3zm0 23.3c-2.1 0-4.1-.6-5.8-1.7l-.4-.2-3.9 1.2 1.2-3.7-.3-.4c-1.2-1.7-1.8-3.7-1.8-5.7C5 9.9 9.9 5.2 16 5.2s11 4.7 11 10.6-4.9 10.5-11 10.5zm6-7.9c-.3-.2-2-1-2.3-1.1-.3-.1-.5-.2-.8.2-.2.3-.9 1.1-1.1 1.3-.2.2-.4.2-.7.1-.3-.2-1.4-.5-2.7-1.6-1-.9-1.7-2-1.9-2.3-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.4.3-.6.1-.2 0-.4 0-.6l-1.1-2.5c-.3-.7-.6-.6-.8-.6h-.7c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.7s1.2 3.1 1.4 3.4c.2.2 2.4 3.6 5.8 5 .8.3 1.4.5 1.9.7.8.3 1.5.2 2.1.1.6-.1 2-.8 2.2-1.6.3-.8.3-1.4.2-1.6-.1-.1-.3-.2-.6-.3z"
    />
  </svg>
);

const CardShell = forwardRef(function CardShell({ children, variant = "product", testId }, ref) {
  return (
    <div ref={ref} className={`mc-card mc-card--${variant}`} data-testid={testId}>
      <div className="mc-grain" />
      <div className="mc-frame">
        <span className="mc-corner mc-corner--tl" />
        <span className="mc-corner mc-corner--tr" />
        <span className="mc-corner mc-corner--bl" />
        <span className="mc-corner mc-corner--br" />
      </div>
      <div className="mc-inner">{children}</div>
    </div>
  );
});

export default CardShell;
